import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Container, Grid, Menu, IconButton, MenuItem, Typography, useMediaQuery } from '@mui/material';
import { Add, AddCircle, ArrowDown2, ArrowUp2, Cup, Security, Star } from 'iconsax-react';
import { addButton, spaceBetween } from './style';
import { ConfirmationDialog } from './dialog/ConfirmationDialog';
import { UploadAction } from '../../../../components/common/actions/UploadAction';
import { PrimaryButon } from '../../../../components/common/button/PrimaryButon';
import { PageHeader } from '../../../../components/common/header/PageHeader';
import CustomSelect from '../../../../components/common/inputs/CustomSelect';
import { QInput } from '../../../../components/common/inputs/QInput';
import { palette } from '../../../../../theme/palette';
import { ClientsInformation } from './ClientsInformation';
import { DownloadAction } from '@ui/components/common/actions/DownloadAction';
import { colCenter } from '@ui/style/style';
import { CustomChip } from '@ui/components/common/chip/Chip';
import { ClientDialog } from './dialog/ClientDialog';
import { useSearchParams } from 'react-router-dom';
import { getCountriesAsync } from '@application/features/country/countryThunk';
import { getUserByIdAsync } from '@application/features/adminUsers/adminUserThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { Controller, useForm } from 'react-hook-form';
import { ContractTypeOptions } from '@application/common/enums/contract-type';
import { formatDateDMY } from '@infrastructure/helpers';
import { translate } from '@application/common/helpers/translate';
import { downloadCOCDocumentAsync, updateFreelancerUserAsync } from '@application/features/freelancer/freelancerThunks';
import { convertToPdfFile, openOrDownloadBlob, openOrDownloadPdf } from '@application/common/helpers/file-helper';
import { UserStatus, UserStatusMap } from '@application/common/enums/user-status';
import { getColorAndBackground } from '@ui/constants/helper';
import { getAllPackagesAsync } from '@application/features/Packages/packageThunk';
import { shouldShowGrid } from '@application/common/helpers/freelancer-account-helper';
import { InternalCompanyOptions } from '@application/common/enums/internal-company';
import { black500 } from '@ui/constants/color';
import { ChangeWarningDialog } from './dialog/ChangeWarningDialog';
import { Tabs } from '@ui/components/common/tabs';
const theme = palette('light');
export const EditUser = () => {
    const [confDialog, setConfDialog] = useState(false);
    const [isAdd, setisAdd] = useState(false);
    const [allDocumentsUploadedFiles, setAllDocumentsUploadedFiles] = useState([]);
    const { currentUser } = useAppSelector((state) => state.auth);
    const { user } = useAppSelector((state) => state.user);
    const { countriesDropdown } = useAppSelector((state) => state.country);
    const [searchParams] = useSearchParams();
    const userId = searchParams.get('id');
    const dispatch = useAppDispatch();
    const fileInputRefContract = useRef(null);
    const fileInputRefAllDocuments = useRef(null);
    const [packageName, setPackageName] = useState(null);
    const [isUserUpdated, setIsUserUpdated] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [popupWarningMessage, setPopupWarningMessage] = useState('');
    const [skipWarning, setskipWarning] = useState(false);
    const [openWarningPopup, setOpenWarningPopup] = useState(false);
    const [pendingUser, setPendingUser] = useState(null);
    const [clientsTab, setClientsTab] = useState('unarchived');
    const clientTabItems = [
        { label: 'Unarchived', value: 'unarchived' },
        { label: 'Archived', value: 'archived' }
    ];
    const { control, handleSubmit, formState: { errors }, trigger, setValue, setError, clearErrors, getValues } = useForm({});
    const handleFileSelection = (event, type) => {
        const files = event.target.files;
        if (files) {
            const fileArray = Array.from(files);
            if (type === 'contract') {
            }
            else {
                fileArray.forEach((file) => {
                    handleFileUpload(file);
                });
            }
        }
        event.target.value = ''; // specifically for to upload same file multiple time
    };
    useEffect(() => {
        dispatch(getCountriesAsync());
        if (userId)
            dispatch(getUserByIdAsync(userId))
                .unwrap()
                .then((result) => {
                dispatch(getAllPackagesAsync())
                    .unwrap()
                    .then((packagesResult) => {
                    const selectedPackageName = packagesResult?.find((x) => x.id.toLowerCase() == result?.userPlanId?.toLowerCase())?.name;
                    setPackageName(selectedPackageName ?? null);
                })
                    .catch((x) => { });
            })
                .catch(() => { });
    }, [dispatch, userId, isAdd, isUserUpdated]);
    useEffect(() => {
        // Check if user and otherDocuments are available before setting state
        if (user && user.userOtherDocuments) {
            setAllDocumentsUploadedFiles(user.userOtherDocuments);
        }
    }, [user]); // This will run whenever the user changes
    const handleAddMoreFiles = (type) => {
        if (type === 'contract') {
            fileInputRefContract.current?.click();
        }
        else {
            fileInputRefAllDocuments.current?.click();
        }
    };
    useEffect(() => {
        if (user) {
            setInitialValues(user);
            const fieldsToUpdate = {
                id: user.id || '',
                otherDocuments: user.userOtherDocuments,
                countryId: user.countryId || '',
                dateOfBirth: user.dateOfBirth || '',
                documentNumber: user.documentNumber || '',
                firstName: user.firstName || '',
                lastName: user.lastName || '',
                email: user.email || '',
                phoneNumber: user.phoneNumber || '',
                Position: user.position || '',
                address: user.address || '',
                zipCode: user.zipCode || '',
                companyName: user.companyName || '',
                bankAccountTitle: user.bankAccountTitle || '',
                companyAddress: user.companyAddress || '',
                companyZipCode: user.companyZipCode || '',
                KVK: user.kvk || '',
                companyCountry: user.companyCountry || '',
                vat: user.vat || '',
                bankAccountNumber: user.bankAccountNumber || '',
                status: user.status !== undefined ? user.status : '',
                projectNumber: user.projectNumber || '',
                contractType: user.contractType || '',
                resourceNumber: user.resourceNumber || '',
                projectTaskNumber: user.projectTaskNumber || '',
                internalCompany: user.internalCompany || ''
            };
            Object.entries(fieldsToUpdate).forEach(([key, value]) => {
                setValue(key, value);
            });
        }
    }, [user, setValue]);
    const convertUrlFileToPDF = (document) => {
        const fileDto = { folderName: document?.folderName, fileName: document?.name };
        dispatch(downloadCOCDocumentAsync(fileDto))
            .unwrap()
            .then((res) => {
            openOrDownloadPdf(res.file, document?.name ?? 'document', 'Chamber of Commerce Document');
        });
    };
    const convertOtherDocumentToPDF = (document) => {
        if (document.documentId === undefined) {
            // This means we're dealing with a File object
            openOrDownloadBlob(document, document.name, document.name);
        }
        else {
            const fileDto = { folderName: document?.folderName, fileName: document?.name };
            dispatch(downloadCOCDocumentAsync(fileDto))
                .unwrap()
                .then((res) => {
                openOrDownloadPdf(res.file, document?.name ?? 'document', 'Chamber of Commerce Document');
            });
        }
    };
    const handleFileUpload = (file) => {
        const allFiles = getValues('otherDocuments') || [];
        const uploadedFile = file;
        // const maxFileSize = 1048576;
        if (uploadedFile) {
            // Determine the new file index for renaming
            const newIndex = allDocumentsUploadedFiles.length > 0 ? allDocumentsUploadedFiles.length : 0;
            // Create a new file name using the index
            const newFileName = `${uploadedFile.name.split('.')[0]}_${newIndex}.${uploadedFile.name.split('.')[1]}`;
            // Create a new File object with the updated name
            const renamedFile = new File([uploadedFile], newFileName, { type: uploadedFile.type });
            const newDocument = {
                type: renamedFile.type,
                size: renamedFile.size,
                fileData: renamedFile
            };
            if (allFiles[0] === undefined) {
                // if first time file upload, array is not made yet
                // Update the form state with the uploaded files
                const filesArrayForSingleFile = [];
                filesArrayForSingleFile.push(newDocument);
                setValue('otherDocuments', filesArrayForSingleFile);
            }
            else if (allFiles.length < 5) {
                const filesArray = [...allFiles, newDocument]; // Add the uploaded file to the array
                setValue('otherDocuments', filesArray); // Set the updated array
            }
            clearErrors('otherDocuments');
            if (allFiles[0] == undefined || allFiles.length < 5)
                setAllDocumentsUploadedFiles((prevFiles) => [...prevFiles, renamedFile]);
        }
        else {
            if (allFiles == undefined || allFiles == null) {
                setValue('otherDocuments', undefined);
                clearErrors('otherDocuments');
            }
        }
    };
    const clearFile = (fileName, type) => {
        if (type === 'contract') {
        }
        else {
            if (allDocumentsUploadedFiles.length == 1)
                clearErrors('otherDocuments');
            const allFiles = allDocumentsUploadedFiles;
            // Filter out the file to be deleted from both state and form control
            const updatedFiles = allFiles.filter((file) => (file.fileData && file.fileData.name !== fileName) || (file.name && file.name != fileName));
            // Update form control for 'otherDocuments'
            setValue('otherDocuments', updatedFiles);
            // Update state if there was only one file
            if (updatedFiles.length === 0) {
                clearErrors('otherDocuments');
            }
            // Remove the specific file from the uploaded files state
            setAllDocumentsUploadedFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
        }
    };
    const onSubmit = async (updatedUser) => {
        if (updatedUser.otherDocuments &&
            updatedUser.otherDocuments.some((file) => {
                return !['application/pdf'].includes(file.type);
            })) {
            setError('otherDocuments', {
                message: translate('validations.onlyPDFAllowed')
            });
            return;
        }
        if (updatedUser.otherDocuments &&
            updatedUser.otherDocuments.some((file) => {
                const maxFileSize = 16777216;
                return file.size > maxFileSize;
            })) {
            setError('otherDocuments', {
                message: translate('validations.maxAllowedFileSize')
            });
            return;
        }
        if (user?.document && (updatedUser.COCDocument === undefined || updatedUser.COCDocument === null)) {
            const fileDto = { folderName: user?.document.folderName, fileName: user?.document?.name };
            try {
                const res = await dispatch(downloadCOCDocumentAsync(fileDto)).unwrap();
                const blob = convertToPdfFile(res.file);
                const file = new File([blob], user.document?.name, { type: 'application/pdf' });
                updatedUser.COCDocument = file;
                // updatedUser.id = user.id;
                updatedUser.dateOfBirth = user.dateOfBirth ? user.dateOfBirth : '';
            }
            catch (error) {
                // return; // Exit the function if COCDocument download fails
            }
        }
        if (updatedUser) {
            const isAnyFilesUploaded = getValues('otherDocuments')?.length;
            if (isAnyFilesUploaded && isAnyFilesUploaded > 0 && updatedUser.otherDocuments && updatedUser.otherDocuments.length > 0) {
                const convertedDocuments = await Promise.all(updatedUser.otherDocuments
                    .filter((x) => x.documentId)
                    .map(async (doc) => {
                    const fileDto = { folderName: doc?.folderName, fileName: doc?.name };
                    try {
                        const res = await dispatch(downloadCOCDocumentAsync(fileDto)).unwrap();
                        const blob = convertToPdfFile(res.file);
                        const file = new File([blob], fileDto?.fileName, { type: 'application/pdf' });
                        return { ...doc, fileData: file };
                    }
                    catch (error) {
                        return null; // Return null if there's an error
                    }
                }));
                const successfulDocuments = convertedDocuments.filter((doc) => doc !== null); // Filter out any null values
                if (successfulDocuments && successfulDocuments.length > 0) {
                    // Ensure all documents which are uploaded previously were processed successfully
                    const existingDocuments = updatedUser.otherDocuments || [];
                    updatedUser.otherDocuments = successfulDocuments.map((doc, index) => ({
                        ...(existingDocuments[index] || {}),
                        fileData: doc ? doc.fileData : undefined,
                        size: doc ? (doc.fileData ? doc.fileData.size : 0) : 0,
                        type: doc ? (doc.fileData ? doc.fileData.type : '') : ''
                    }));
                    const newlyAddedFiles = existingDocuments.filter((x) => !x.documentId);
                    updatedUser.otherDocuments = [...updatedUser.otherDocuments, ...newlyAddedFiles];
                    return dispatch(updateFreelancerUserAsync(updatedUser))
                        .unwrap()
                        .then((response) => {
                        if (response && response.userOtherDocuments) {
                            setAllDocumentsUploadedFiles(response.userOtherDocuments);
                            updatedUser.otherDocuments = response.userOtherDocuments;
                            setValue('otherDocuments', response.userOtherDocuments);
                        }
                        if (userId != null) {
                            dispatch(getUserByIdAsync(userId));
                        }
                        setConfDialog(false);
                        setIsUserUpdated(true);
                    })
                        .catch((error) => { });
                }
                else if (updatedUser.otherDocuments && updatedUser.otherDocuments.filter((x) => x.documentId === null)) {
                    // Ensure all documents which are uploaded previously were processed successfully
                    const existingDocuments = updatedUser.otherDocuments || [];
                    updatedUser.otherDocuments = successfulDocuments.map((doc, index) => ({
                        ...(existingDocuments[index] || {}),
                        fileData: doc ? doc.fileData : undefined,
                        size: doc ? (doc.fileData ? doc.fileData.size : 0) : 0,
                        type: doc ? (doc.fileData ? doc.fileData.type : '') : ''
                    }));
                    const newlyAddedFiles = existingDocuments.filter((x) => !x.documentId);
                    updatedUser.otherDocuments = [...updatedUser.otherDocuments, ...newlyAddedFiles];
                    return dispatch(updateFreelancerUserAsync(updatedUser))
                        .unwrap()
                        .then((response) => {
                        if (response && response.userOtherDocuments) {
                            setAllDocumentsUploadedFiles(response.userOtherDocuments);
                            updatedUser.otherDocuments = response.userOtherDocuments;
                            setValue('otherDocuments', response.userOtherDocuments);
                        }
                        if (userId != null) {
                            dispatch(getUserByIdAsync(userId));
                        }
                        setConfDialog(false);
                        setIsUserUpdated(true);
                    })
                        .catch((error) => { });
                }
                else {
                    //console.error("Not all documents were processed successfully.");
                    // Optionally handle the case where not all documents were successful
                }
            }
            else {
                return dispatch(updateFreelancerUserAsync(updatedUser))
                    .unwrap()
                    .then((response) => {
                    if (response && response.userOtherDocuments) {
                        setAllDocumentsUploadedFiles(response.userOtherDocuments);
                        updatedUser.otherDocuments = response.userOtherDocuments;
                        setValue('otherDocuments', response.userOtherDocuments);
                    }
                    if (userId != null) {
                        dispatch(getUserByIdAsync(userId));
                    }
                    setConfDialog(false);
                    setIsUserUpdated(true);
                })
                    .catch((error) => { });
            }
        }
    };
    const handleSaveChanges = () => {
        handleSubmit(onSubmit)();
        setOpenWarningPopup(false);
    };
    const getUserStatusOptions = (shouldShowGrid) => {
        if (!shouldShowGrid) {
            // Return only the Pending status option if shouldShowGrid is false
            return [
                {
                    label: UserStatusMap.get(UserStatus.Pending) || 'Pending',
                    value: UserStatus.Pending // Numeric index as string
                }
            ];
        }
        // Return all status options if shouldShowGrid is true
        return Object.keys(UserStatus)
            .filter((key) => !isNaN(Number(UserStatus[key]))) // Ensures we only get the enum values
            .map((key) => ({
            label: UserStatusMap.get(UserStatus[key]) || key,
            value: UserStatus[key] // Numeric index as string
        }));
    };
    const userStatusOptions = Object.keys(UserStatus)
        .filter((key) => !isNaN(Number(UserStatus[key]))) // Ensures we only get the enum values
        .map((key) => ({
        label: UserStatusMap.get(UserStatus[key]) || key,
        value: UserStatus[key] // Numeric index as string
    }));
    // helper function to check warning conditions
    const checkForWarnings = (updatedUser) => {
        if (!initialValues)
            return null;
        const hasInternalChanged = initialValues.internalCompany !== undefined && updatedUser.internalCompany !== initialValues.internalCompany;
        const hasContractChanged = initialValues.contractType !== undefined && updatedUser.contractType !== initialValues.contractType;
        if (hasInternalChanged && hasContractChanged) {
            return 'If you change both Contract Type and Internal Department, all existing contracts will expire.';
        }
        else if (hasInternalChanged) {
            return 'If you change the Internal Department, all existing contracts will expire.';
        }
        else if (hasContractChanged) {
            return 'If you change the Contract Type, all existing contracts will expire.';
        }
        return null;
    };
    const handleSaveClick = (data) => {
        const warningMessage = checkForWarnings(data);
        if (warningMessage) {
            setPopupWarningMessage(warningMessage);
            setOpenWarningPopup(true);
            setPendingUser(data);
            return;
        }
        // if no warning → just submit
        onSubmit(data);
    };
    const isXl = useMediaQuery('(min-width: 1625px) and (max-width: 3000px)');
    return (_jsxs("div", { children: [_jsx(PageHeader, { goback: true, title: user && user.firstName + ' ' + user.lastName, startComponent: _jsxs(Box, { sx: { ...colCenter, gap: 1 }, children: [_jsx(Controller, { name: 'status', control: control, render: ({ field }) => {
                                const options = getUserStatusOptions(shouldShowGrid(user));
                                // const options = getUserStatusOptions(true);
                                return (_jsx(ContainedSelect, { defaultValue: field.value, options: options, onSelect: (value) => field.onChange(value) }));
                            } }), packageName && (_jsx(CustomChip, { value: `Historical package: ${packageName}`, size: 'medium', icon: packageName && packageName == 'Premium' ? (_jsx(Cup, { color: '#316F1D', size: 17 })) : packageName && packageName == 'Basic' ? (_jsx(Security, { color: '#316F1D', size: 17 })) : packageName && packageName == 'Advanced' ? (_jsx(Star, { color: '#316F1D', size: 17 })) : ('') }))] }), children: _jsx(Box, { width: '350px', children: _jsx(PrimaryButon, { motion: true, onClick: handleSubmit(handleSaveClick), children: "Save changes" }) }) }), _jsxs(Container, { maxWidth: false, children: [_jsxs(Grid, { container: true, spacing: 2, mb: 2, display: 'flex', alignItems: 'flex-end', children: [_jsxs(Grid, { item: true, xs: 6, md: 3, children: [_jsx(Typography, { variant: 'h5', mb: 1, color: 'initial', children: "Contract type" }), _jsx(Controller, { name: 'contractType', control: control, defaultValue: '', render: ({ field }) => (_jsx(CustomSelect, { label: 'Contract type', height: 53.13, options: ContractTypeOptions, selectedOption: field.value, handleChange: (value) => field.onChange(value), errormsg: errors.contractType ? errors.contractType.message : '' })) })] }), _jsx(Grid, { item: true, xs: 6, md: 3, children: _jsx(Controller, { name: 'resourceNumber', control: control, defaultValue: '', rules: {
                                        required: { value: true, message: translate('validations.fieldIsRequired') },
                                        maxLength: {
                                            value: 20,
                                            message: translate('validations.maximumCharactersAllowed', { count: 20 })
                                        }
                                    }, render: ({ field }) => (_jsx(QInput, { ...field, placeholder: 'Resource number', errormsg: errors.resourceNumber ? errors.resourceNumber.message : '', label: 'Resource number' })) }) }), _jsxs(Grid, { item: true, xs: 6, md: 3, children: [_jsx(Typography, { variant: 'subtitle2', color: black500, children: "Internal Department" }), _jsx(Controller, { name: 'internalCompany', rules: {
                                            required: { value: true, message: translate('validations.fieldIsRequired') }
                                        }, control: control, defaultValue: '', render: ({ field }) => (_jsx(CustomSelect, { height: 53.13, label: 'Internal Department', options: InternalCompanyOptions, selectedOption: field.value, handleChange: (value) => field.onChange(value), errormsg: errors.internalCompany ? errors.internalCompany.message : '' })) })] })] }), _jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, md: 6, padding: 1, children: _jsx(Box, { sx: {
                                        height: 'calc(100svh - 370px)',
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '15px',
                                        overflow: 'hidden',
                                        background: theme.common.white
                                    }, children: _jsxs(Box, { sx: { overflowY: 'scroll', height: 'calc(100svh - 390px)' }, padding: '15px', children: [_jsx(Typography, { variant: 'h5', color: 'black', children: "Personal information" }), _jsxs(Grid, { container: true, spacing: 2, mt: 1.5, children: [_jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'firstName', control: control, defaultValue: '', rules: {
                                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                                minLength: {
                                                                    value: 2,
                                                                    message: translate('validations.minimumCharactersAllowed', { count: 2 })
                                                                },
                                                                maxLength: {
                                                                    value: 100,
                                                                    message: translate('validations.maximumCharactersAllowed', { count: 100 })
                                                                }
                                                            }, render: ({ field }) => (_jsx(QInput, { ...field, label: 'First name', errormsg: errors.firstName ? errors.firstName.message : '' })) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'lastName', control: control, defaultValue: '', rules: {
                                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                                minLength: {
                                                                    value: 2,
                                                                    message: translate('validations.minimumCharactersAllowed', { count: 2 })
                                                                },
                                                                maxLength: {
                                                                    value: 100,
                                                                    message: translate('validations.maximumCharactersAllowed', { count: 100 })
                                                                }
                                                            }, render: ({ field }) => (_jsx(QInput, { ...field, label: 'Last name', errormsg: errors.lastName ? errors.lastName.message : '' })) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'zipCode', control: control, defaultValue: '', rules: {
                                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                                maxLength: {
                                                                    value: 10,
                                                                    message: translate('validations.maximumCharactersAllowed', { count: 10 })
                                                                }
                                                            }, render: ({ field }) => (_jsx(QInput, { ...field, label: 'Postal code', errormsg: errors.zipCode ? errors.zipCode.message : '' })) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'address', control: control, defaultValue: '', rules: {
                                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                                maxLength: {
                                                                    value: 40,
                                                                    message: translate('validations.maximumCharactersAllowed', { count: 40 })
                                                                }
                                                            }, render: ({ field }) => (_jsx(QInput, { ...field, label: 'Address', errormsg: errors.address ? errors.address.message : '' })) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'dateOfBirth', control: control, defaultValue: '', rules: {
                                                                required: { value: true, message: translate('validations.fieldIsRequired') }
                                                            }, render: ({ field }) => (_jsx(QInput, { disabled: true, value: formatDateDMY(user?.dateOfBirth ? new Date(user?.dateOfBirth) : undefined), label: 'Date of birth', errormsg: errors.dateOfBirth ? errors.dateOfBirth.message : '' })) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'documentNumber', control: control, defaultValue: '', rules: {
                                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                                maxLength: {
                                                                    value: 20,
                                                                    message: translate('validations.maximumCharactersAllowed', { count: 20 })
                                                                }
                                                            }, render: ({ field }) => (_jsx(QInput, { disabled: true, ...field, label: 'Document number', errormsg: errors.documentNumber ? errors.documentNumber.message : '' })) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'email', control: control, defaultValue: '', rules: {
                                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                                pattern: {
                                                                    value: /^\S+@\S+\.\S+$/,
                                                                    message: translate('validations.invalidEmailAddress')
                                                                }
                                                            }, render: ({ field }) => (_jsx(QInput, { disabled: true, ...field, label: 'Email address', errormsg: errors.email ? errors.email.message : '' })) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'countryId', control: control, defaultValue: '', rules: {
                                                                required: { value: true, message: translate('validations.fieldIsRequired') }
                                                            }, render: ({ field }) => (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: 'subtitle2', color: black500, children: "Land of origin" }), _jsx(CustomSelect, { label: 'Land of origin', height: 53.13, options: countriesDropdown, selectedOption: field.value, handleChange: (value) => field.onChange(value), errormsg: errors.countryId ? errors.countryId.message : '' })] })) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'phoneNumber', control: control, defaultValue: '', rules: {
                                                                required: { value: true, message: translate('validations.fieldIsRequired') }
                                                            }, render: ({ field }) => (_jsx(QInput, { ...field, label: 'Phone number', errormsg: errors.phoneNumber ? errors.phoneNumber.message : '' })) }) })] }), user && user.contractType !== 'Seconded' && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: 'h5', mt: 5, mb: 2, color: 'black', children: "Company information" }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'companyName', control: control, defaultValue: '', render: ({ field }) => _jsx(QInput, { ...field, disabled: true, label: 'Company name' }) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'companyCountry', control: control, defaultValue: '', render: ({ field }) => (_jsx(QInput, { disabled: true, value: countriesDropdown?.find((c) => c.value === user?.companyCountry)?.label, label: 'Country of establishment' })) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'bankAccountTitle', control: control, defaultValue: '', render: ({ field }) => _jsx(QInput, { ...field, disabled: true, label: 'Account holder name' }) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'vat', control: control, defaultValue: undefined, render: ({ field }) => _jsx(QInput, { ...field, disabled: true, label: 'BTW number' }) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'companyAddress', control: control, defaultValue: '', render: ({ field }) => _jsx(QInput, { ...field, disabled: true, label: 'Business address' }) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'bankAccountNumber', control: control, defaultValue: undefined, render: ({ field }) => _jsx(QInput, { ...field, disabled: true, label: 'Bank account number' }) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'companyZipCode', control: control, defaultValue: '', render: ({ field }) => _jsx(QInput, { ...field, disabled: true, label: 'Postal code' }) }) }), _jsx(Grid, { item: true, md: 6 }), _jsx(Grid, { item: true, md: 6, children: _jsx(Controller, { name: 'KVK', control: control, defaultValue: '', render: ({ field }) => _jsx(QInput, { ...field, disabled: true, label: 'KVK' }) }) })] })] }))] }) }) }), _jsx(Grid, { item: true, md: 3, padding: 1, children: _jsxs(Box, { sx: {
                                        height: 'calc(100svh - 370px)',
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '15px',
                                        overflow: 'hidden',
                                        background: theme.black.lighter,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }, children: [_jsxs(Box, { sx: { ...spaceBetween, px: 3, py: 1 }, children: [_jsx(Typography, { variant: 'h5', color: 'black', children: "Clients" }), _jsx(IconButton, { sx: { border: '1px solid gray' }, size: 'small', onClick: () => setisAdd(true), children: _jsx(Add, {}) })] }), _jsx(Box, { sx: { px: 3, pb: 1, flexShrink: 0 }, children: _jsx(Tabs, { tabs: clientTabItems, activeTab: clientsTab, onChange: (val) => setClientsTab(val) }) }), _jsx(Box, { sx: { flex: 1, overflowY: 'auto', minHeight: 0 }, padding: '15px', pt: 0, children: _jsx(ClientsInformation, { showArchived: clientsTab === 'archived' }) })] }) }), _jsxs(Grid, { item: true, md: 3, padding: 1, children: [_jsxs(Box, { children: [_jsx(Typography, { variant: 'h5', color: 'black', mb: 1, children: "KvK document" }), _jsx(DownloadAction, { fileName: user?.document?.name, type: 'download', width: '100%', onClick: () => {
                                                    if (user?.document) {
                                                        convertUrlFileToPDF(user.document);
                                                    }
                                                    else {
                                                        return;
                                                    }
                                                } })] }), _jsxs(Box, { children: [_jsxs(Box, { sx: { display: 'flex', justifyContent: 'space-between', mt: 1, mb: 1 }, children: [_jsx(Typography, { variant: 'h5', color: 'black', children: "All documents" }), allDocumentsUploadedFiles.length > 0 && allDocumentsUploadedFiles.length < 5 && (_jsx(Button, { size: 'small', sx: { ...addButton }, endIcon: _jsx(AddCircle, {}), onClick: () => handleAddMoreFiles('allDocuments'), children: "Add more" }))] }), allDocumentsUploadedFiles.length > 0 ? (allDocumentsUploadedFiles.map((item) => {
                                                return (_jsxs(Box, { mt: 0.5, children: [_jsx(Controller, { name: 'otherDocuments', control: control, render: ({ field }) => {
                                                                return (_jsx(DownloadAction, { width: '100%', haveClear: true, clear: () => clearFile(item.name, 'allDocuments'), fileName: item.name, type: 'download', onClick: () => {
                                                                        if (item) {
                                                                            convertOtherDocumentToPDF(item);
                                                                        }
                                                                        else {
                                                                            return;
                                                                        }
                                                                    } }));
                                                            } }), errors.otherDocuments && (_jsx(Box, { sx: { position: 'absolute' }, children: _jsx(Typography, { variant: 'caption', fontWeight: 500, ml: 2, color: '#FF0000', children: errors.otherDocuments.message }) }))] }));
                                            })) : (_jsx(Box, { children: _jsx(Controller, { name: 'otherDocuments', control: control, rules: {
                                                        // required: { value: true, message: translate('validations.fieldIsRequired') },
                                                        validate: {
                                                            fileType: (files) => {
                                                                files = Array.from(files);
                                                                if (files && files.some((file) => !['application/pdf'].includes(file.type))) {
                                                                    return translate('validations.onlyPDFAllowed');
                                                                }
                                                                return true;
                                                            },
                                                            fileSize: (files) => {
                                                                files = Array.from(files);
                                                                if (files && files.some((file) => file.size > 16777216)) {
                                                                    return translate('validations.maxAllowedFileSize');
                                                                }
                                                                return true;
                                                            }
                                                        }
                                                    }, render: ({ field }) => {
                                                        return (_jsx(UploadAction, { onFileUpload: (file) => {
                                                                field.onChange(file);
                                                                handleFileUpload(file);
                                                            }, px: 10, variant: allDocumentsUploadedFiles.length === 0 ? 'contained' : 'outLined', h: allDocumentsUploadedFiles.length === 0 ? 286 : 75, text: 'Upload Documents', errormsg: errors.otherDocuments ? errors.otherDocuments.message : '' }));
                                                    } }) })), _jsx("input", { type: 'file', multiple: true, ref: fileInputRefAllDocuments, onChange: (e) => handleFileSelection(e, 'allDocuments'), style: { display: 'none' } })] })] })] })] }), _jsx(ChangeWarningDialog, { handleClose: () => setOpenWarningPopup(false), open: openWarningPopup, dialogContent: popupWarningMessage, handleSaveChanges: handleSaveChanges }), _jsx(ConfirmationDialog, { handleClose: () => setConfDialog(false), open: confDialog, handleSaveChanges: handleSaveChanges }), _jsx(ClientDialog, { type: 'add', open: isAdd, handleClose: () => setisAdd(false), contractType: user?.contractType })] }));
};
const ContainedSelect = ({ options, defaultValue, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(undefined);
    const [selectAnchorEl, setSelectAnchorEl] = useState(null);
    const { color, background } = getColorAndBackground(selectedOption?.label);
    useEffect(() => {
        if (options.length > 0 && defaultValue !== undefined) {
            const defaultOption = options.find((option) => option.value === defaultValue);
            setSelectedOption(defaultOption);
        }
    }, [options, defaultValue]);
    const handleClick = (event) => {
        setSelectAnchorEl(event.currentTarget);
        setIsOpen(true);
    };
    const handleMenuClose = (option) => {
        if (option) {
            setSelectedOption(option);
            if (onSelect) {
                onSelect(option.value);
            }
        }
        setSelectAnchorEl(null);
        setIsOpen(false);
    };
    return (_jsxs("div", { children: [_jsx(Box, { width: 120, children: _jsx(Button, { fullWidth: true, variant: 'soft', size: 'small', style: { backgroundColor: background }, color: 'inherit', onClick: handleClick, endIcon: isOpen ? _jsx(ArrowUp2, { size: '16px' }) : _jsx(ArrowDown2, { size: '16px' }), sx: {
                        justifyContent: 'space-between',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        fontWeight: 400
                    }, children: selectedOption ? selectedOption.label : 'Select Option' }) }), _jsx(Menu, { anchorEl: selectAnchorEl, open: Boolean(selectAnchorEl), onClose: () => handleMenuClose(), children: options.map((option) => (_jsx(MenuItem, { onClick: () => handleMenuClose(option), children: option.label }, option.value))) })] }));
};
